import { APP_MODULE_NAME } from '../utils/ModuleMap';
export const SET_EMAIL = `${APP_MODULE_NAME}/privacy/SET_EMAIL`;
export const SET_PREFERENCE = `${APP_MODULE_NAME}/privacy/SET_PREFERENCE`;
export const SET_PREFERENCE_STATUS = `${APP_MODULE_NAME}/privacy/SET_PREFERENCE_STATUS`;
export const SET_ORIGINAL_PREFERENCE_STATUS = `${APP_MODULE_NAME}/privacy/SET_ORIGINAL_PREFERENCE_STATUS`;
export const SET_APPLICATION_TOKEN = `${APP_MODULE_NAME}/privacy/SET_APPLICATION_TOKEN`;
export const SET_IS_LOADING = `${APP_MODULE_NAME}/privacy/SET_IS_LOADING`;
export const SET_IDAAS_TOKEN = `${APP_MODULE_NAME}/privacy/SET_IDAAS_TOKEN`;
export const SET_IDAAS_FAILURE = `${APP_MODULE_NAME}/privacy/SET_IDAAS_FAILURE`;
export const SET_CARD_TOKEN = `${APP_MODULE_NAME}/privacy/SET_CARD_TOKEN`;